import {Controller} from '@hotwired/stimulus';
import * as Turbo from '@hotwired/turbo';

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 2000 } };

  connect() {
    this.timer = setTimeout(() => this.refresh(), this.intervalValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  refresh() {
    Turbo.visit(this.urlValue, { action: 'replace' });
  }
}